// extracted by mini-css-extract-plugin
module.exports = {"title":"modal-error_title__QNGA_","icon":"modal-error_icon__LJtiY","description":"modal-error_description__1smEl","container":"modal-error_container__2eaWq"};